import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import Empty from '@jd/jmtd/es/Empty';
import classNames from '@jd/jmtd-tools/es/classnames';
export default function Chart(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('jmtc-chart', className, _defineProperty({}, "jmtc-chart-".concat(theme), theme))
  }, children, /*#__PURE__*/React.createElement(Empty, {
    className: "jmtc-empty"
  }));
}
Chart.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.string
};
Chart.defaultProps = {
  children: null,
  className: '',
  theme: null
};